import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { normalizeHttpError } from '../../errors/error-normalizer';
import { Logger } from '../../logging/logger.service';

export const errorNormalizationInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(Logger);

  return next(req).pipe(
    catchError((error: unknown) => {
      const normalizedError = normalizeHttpError(error);

      logger.error('Normalized HTTP error', {
        correlationId: normalizedError.correlationId,
        feature: 'http',
        operation: 'error-normalization',
        severity: normalizedError.severity,
        code: normalizedError.code,
      });

      return throwError(() => normalizedError);
    }),
  );
};
